export enum SectionType {
  FooterSignUp = 1,
  CouponSignUp = 6,
}
